module.exports = __webpack_public_path__ + "img/1.f2cf6126.jpg";